import React, { HTMLAttributes } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
}

export function Card({
  children,
  className = '',
  hoverEffect = false,
  ...props
}: CardProps) {
  // Default padding of p-6 can be overridden by passing a different padding class
  const hasCustomPadding = className.includes(' p-') || className.startsWith('p-');
  const defaultPadding = hasCustomPadding ? '' : 'p-6';
  
  return (
    <div
      className={`bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden ${defaultPadding} ${
        hoverEffect ? 'transition-shadow hover:shadow-md' : ''
      } ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export default Card;
